<script>
    import Showcase from "../components/Showcase.svelte";
    import PortfolioGrid from "../components/portfolio/PortfolioGrid.svelte";
</script>

<svelte:head>
	<title>PotatoSites | Web dev</title>
</svelte:head>

<Showcase />

<section class="container grid-lg about">
    <div class="columns">
        <div class="column col-12">
            <h2 class="text-center text-uppercase" id="about">About</h2>
            <p class="text-justify about__paragraph">
                Hello, my name is Igor I'm a full-stack developer based in Ukraine. 
                I love crafting interactive, fun and user-friendly interfaces, yet usability and user experience is always my top priority. 
                Besides doing a simple design work I also love to bring my interfaces to life with front-end and back-end development.
            </p>
            <div class="d-flex profile">
                <a href="https://gitlab.com/prst22" target="_blank" class="tooltip profile__link" data-tooltip="Gitlab profile">
                    <svg version="1.1" class="svg_icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 200 200" style="enable-background:new 0 0 200 200;" xml:space="preserve">
                        <circle class="fill_black" cx="100" cy="100" r="100"/>
                        <path class="fill_white" d="M23.4,81.8l44.9,43.1V81.8L49.2,23c-1-3-5.6-3-6.6,0L23.4,81.8z"/>
                        <path class="fill_white" d="M176.6,81.8l-44.9,43.1V81.8L150.8,23c1-3,5.6-3,6.6,0L176.6,81.8z"/>
                        <path class="fill_white" d="M100,179.3L28.2,81.8h143.6L100,179.3z"/>
                        <path class="fill_white" d="M100,179.3L68.3,81.8H23.4l19.2,52.7L100,179.3z"/>
                        <path class="fill_white" d="M100,179.3l31.7-97.5h44.9l-19.2,52.7L100,179.3z"/>
                        <path class="fill_white" d="M23.4,81.8l-9.1,29.5c-0.9,2.7,0,5.7,2.4,7.5l83.4,60.6L23.4,81.8z"/>
                        <path class="fill_white" d="M176.6,81.8l9.1,29.5c0.9,2.7,0,5.7-2.4,7.5L100,179.3L176.6,81.8z"/>
                    </svg>
                </a>
            </div>
        </div>
        <div class="column col-4 col-lg-6 col-sm-12">
            <ul>
                <li>HTML5</li>
                <li>CSS3</li>
                <li>CSS animations</li>
                <li>SVG animations</li>
                <li>JavaScript (4 years)</li>
                <li>jQuery</li>
                <li>Responsive design</li>
            </ul>
        </div>
        <div class="column col-4 col-lg-6 col-sm-12">
            <ul>
                <li>Cross-browser development</li>
                <li>SASS</li>
                <li>BEM</li>
                <li>GSAP</li>
                <li>Webpack</li>
                <li>npm</li>
                <li>Gulp</li>
            </ul>
        </div>
        <div class="column col-4 col-lg-6 col-sm-12">
            <ul>
                <li>PHP (4 years)</li>
                <li>Wordpress (4 years)</li>
                <li>Laravel (2 years)</li>
                <li>Vue.js (1 year)</li>
                <li>Svelte</li>
                <li>On page SEO</li>
            </ul>
        </div>
        <div class="column col-4 col-lg-6 col-sm-12">
            <ul>
                <li>Understanding key SEO concepts</li>
            </ul>
        </div>
    </div>
</section>

<PortfolioGrid />

<style lang="scss">
    .about{
        ul{
            list-style: none;
            margin-left: 0; 
            padding-left: 0;
        }
        margin-bottom: 4rem;
    }
    .profile{
        justify-content: center;
        margin: 1.5rem 0 0.5rem 0;
        &__link{
            width: 40px;
            height: 40px;
            border-radius: 40px;

        }
    }
</style>